<div class="info-detail-wrapper">
    <div [class]="'info-detail ' + class">
        <p *ngIf="!isDealsPage" [style]="'margin-right: 5px;'" class="label">{{ label }}:&nbsp;</p>
        <p class="value" *ngIf="value">{{ value }}</p>
        <ng-content *ngIf="!value"></ng-content>
    </div>
</div>
